import React, { useState } from "react";
import "./GalleryPage.css";
import "../PageStyle.css";
import Data from "./Data";

import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

import "swiper/css";
import "swiper/css/navigation";
import { FaXmark } from "react-icons/fa6";

function GalleryPage(props) {
    const [images, setImages] = useState(Data);
    const [categories, setCategories] = useState(["VŠE", ...new Set(images.map((image) => image.category))]);
    const [clickedImage, setClickedImage] = useState(null);

    const displaySeasonImages = (category) => {
        const filteredImages = Data.filter((image) => (image.category === category ? image : null));
        if (filteredImages.length === 0) return setImages(Data); // this is for ALL images
        setImages(filteredImages);
    };

    const getImageByPosition = (clickedImagePosition) => {
        if (clickedImagePosition < 0) {
            setClickedImage(images.length - 1);
            return images[0].image;
        }
        if (clickedImagePosition >= images.length) {
            setClickedImage(0);
            return images[images.length - 1].image;
        }
        return images[clickedImagePosition].image;
    };

    return (
        <div className="container front-page gallery-page d-flex flex-column w-100 justify-content-center align-content-center" id={"gallery-page"}>
            <h1>FotoGalerie</h1>
            <div className={"d-flex justify-content-center p-3"}>
                {categories.map((category, index) => (
                    <button className="category-button" key={index} onClick={() => displaySeasonImages(category)}>
                        {category}
                    </button>
                ))}
            </div>
            <div className="grid-wrapper">
                {images.map((image, index) => (
                    <div key={index} className={"blur-load"}>
                        <img alt="image" loading={"lazy"} src={image.image} onClick={() => setClickedImage(index)} />
                    </div>
                ))}
            </div>

            {clickedImage !== null && (
                <div class={"container"}>
                    {/* Modal */}
                    {clickedImage !== null && (
                        <div className={`modal-fullscreen show`}>
                            {/* Close button */}
                            <button onClick={() => setClickedImage(null)} className="close-btn" aria-label="Close modal">
                                <FaXmark size={24} />
                            </button>

                            {/* Navigation arrows */}
                            <button
                                onClick={() => setClickedImage((prev) => (prev - 1 + images.length) % images.length)}
                                className="nav-arrow-btn prev-btn"
                                aria-label="Previous image"
                            >
                                <FaChevronLeft size={32} />
                            </button>

                            <button
                                onClick={() => setClickedImage((prev) => (prev + 1) % images.length)}
                                className="nav-arrow-btn next-btn"
                                aria-label="Next image"
                            >
                                <FaChevronRight size={32} />
                            </button>

                            {/* Image counter */}
                            <div className="image-counter">
                                {clickedImage + 1} / {images.length}
                            </div>

                            {/* Main image container */}
                            <div className="image-container">
                                <img
                                    src={getImageByPosition(clickedImage)}
                                    alt={`Gallery image ${clickedImage + 1}`}
                                    className="img-fluid main-image fade-in"
                                    style={{
                                        objectFit: "contain",
                                        width: "90vw",
                                        height: "90vh",
                                        transition: "opacity 0.3s ease-in-out, filter 0.3s ease-in-out",
                                        backgroundColor: "transparent",
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default GalleryPage;
